/**
 * Full-viewport amber frame shown for the duration of an impersonation
 * session. Purely decorative (`aria-hidden`, `pointer-events-none`) — an
 * ambient, always-on cue that the whole app is being driven "as" someone
 * else, so an operator can never lose track of it while scrolled away from
 * the <ImpersonationBanner/>. Paired with that banner (which carries the
 * label + Exit control).
 */
import { useMe } from "@/lib/me";

export function ImpersonationFrame() {
  const { data: me } = useMe();
  if (!me?.impersonation) return null;

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-40"
      style={{
        // Solid inner hairline + soft inward glow, hugging the viewport edge.
        boxShadow:
          "inset 0 0 0 2.5px rgb(245 158 11 / 0.9), inset 0 0 24px 4px rgb(245 158 11 / 0.28)",
      }}
    />
  );
}
